import styled from '@emotion/styled';
export const StyledBox = styled.div(({ theme }) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.light['spacing.16']};
  border-color: ${theme.light['color.border.light.default']};
  border-style: solid;
  border-width: ${theme.light['borderWidth.1']};
  background-color: ${theme.light['color.background.default']};
  height: 80px;

  @media (min-width: 768px) {
    border-radius: ${theme.light['radius.16']};
  }
`);
